<template>
  <div class="add-point-block">
    <div class="title">Новая характерная точка</div>
    <div class="coords-block">
      <div class="coord-block">
        <input
          class="coord-input"
          placeholder="широта"
          v-model="lat"
          type="number"
          step="any"
          :disabled="!actLpoIsDraft"
        />
      </div>
      <div class="coord-block">
        <input
          class="coord-input"
          placeholder="долгота"
          v-model="lon"
          type="number"
          :disabled="!actLpoIsDraft"
        />
      </div>
    </div>
    <div class="add-after-block">
      <div>
        <span>Добавить после</span>
        <input
          class="input-after"
          type="number"
          v-model="after"
          :disabled="!actLpoIsDraft"
        />
      </div>
    </div>
    <div class="btn-container">
      <button
        class="btn-common add-btn"
        @click="add"
        :disabled="!actLpoIsDraft"
      >
        Добавить
      </button>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "AddBlock",
  data() {
    return {
      lat: null,
      lon: null,
      after: null,
    };
  },
  computed: {
    actLpoIsDraft() {
      return this.$store.getters["lpoData/actLpoIsDraft"];
    },

    pointList() {
      return this.$store.state.actLpo.geometry["actPointList"];
    },
  },
  watch: {
    pointList(val) {
      this.after = this.pointList.length;
    },
  },
  methods: {
    add() {
      if (this.lat === null || this.lat === "" || isNaN(this.lat)) {
        console.log("wrong lat: ", this.lat);
        return;
      }
      if (this.lon === null || this.lon === "" || isNaN(this.lon)) {
        console.log("wrong lon: ", this.lon);
        return;
      }
      if (this.after < 0 || this.after > this.pointList.length) {
        console.log("wrong after: ", this.after);
        return;
      }

      const point = {
        lat: this.lat,
        lon: this.lon,
        after: this.after,
      };

      this.addPoint(point).then((res) => {
        return this.getActPointList();
      });
    },

    ...mapActions("actLpo", ["addPoint", "getActPointList"]),
  },
  created() {
    this.after = this.pointList.length;
  },
};
</script>

<!-- <style scoped src='@/style/button.css'></style> -->

<style scoped>
.add-point-block {
  background-color: #ededed;
  border: 1px solid #777;
  padding: 10px;
}

.title {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 10px;
}

.coord-input {
  width: 100%;
  box-sizing: border-box;
  font-size: 15px;
  height: 32px;
  padding-left: 10px;

  margin-bottom: 4px;
}

.coord-block {
  /*display: inline-block;*/
  /*width: 50%;*/
}

.add-after-block {
  margin-bottom: 4px;
}
.add-after-block::after {
  clear: both;
  content: "";
  display: table;
}
.add-after-block > div {
  float: right;
}

.add-after-block span {
  color: #777;
  font-style: italic;
}

.input-after {
  font-size: 15px;
  height: 32px;
  padding-left: 10px;
  margin-left: 10px;
  width: 80px;
}

.add-btn {
  width: 100%;
}
</style>
